import { axios } from '@Root/API'

export const getAll = (entryQualificationAwardId, params) => {
	return axios.get(`qualification-subject/qualification-award/${entryQualificationAwardId}`, { params })
}
